import React from 'react';
import { useHistory } from 'react-router-dom';

import ModalConfirmation from '../../components/ModalConfirmation';

const Success = () => {
	const [isShowModal, setIsShowModal] = React.useState(false);
	const history = useHistory();
	const handleClick = () => history.push('/inventory-control');

	const cancelButtonRef = React.useRef(null);

	React.useEffect(() => {
		setIsShowModal(true);
	}, []);

	const closeModalBackground = () => undefined;
	return (
		<div className="flex flex-col min-h-screen overflow-hidden">
			<ModalConfirmation
				icon="/images/success.svg"
				title="Berhasil Menyimpan Jadwal"
				description="Kamu berhasil menyimpan jadwal outlet!"
				cancelButtonRef={cancelButtonRef}
				isShowModal={isShowModal}
				onClick={handleClick}
				closeModalBackground={closeModalBackground}
				variantButton="SINGLE"
				textCenter="Oke, Mengerti"
			/>
		</div>
	);
};

export default Success;
